import {
  SETTINGS_PANEL_LOCALIZATION_SLUG,
  SETTINGS_PANEL_SEARCH_SLUG,
} from '@packages/systems/designer/settings';
import {
  ADD_FROM_LIBRARIES_TAB,
  ADD_ELEMENT_TAB,
} from '@packages/systems/designer/add-panel';

export const BASE_CMS_PANEL = 'cms' as const;
export const ACTIVITY_LOG_PANEL = 'activityLog' as const;
export const ADD_PANEL = 'add' as const;
export const AD_SET_CREATION_PANEL = 'ad-set-creation' as const;
export const ACTIVATE_PANEL = 'activate' as const;
export const AI_ASSISTANT_PANEL = 'ai-assistant-panel' as const;
export const ASSETS_PANEL = 'assets' as const;
export const CAMPAIGNS_PANEL = 'campaigns' as const;
export const CAMPAIGN_OVERVIEW_PANEL = 'campaign-overview' as const;
export const BRAND_PANEL = 'brand' as const;
export const CAMPAIGN_PAGE_SETTINGS_PANEL = 'campaignPageSettings' as const;
export const CAMPAIGN_PAGE_SETTINGS_DETAIL_PANEL =
  'campaignPageSettingsDetail' as const;
export const PERSONALIZATION_TABLE_PANEL = 'personalizationTable' as const;
export const ALL_CAMPAIGNS_PANEL = 'all-campaigns' as const;
export const CAMPAIGNS_HOME_PANEL = 'campaigns-home' as const;
export const CAMPAIGNS_HOME_TRACKING_PANEL = 'campaigns-home-tracking' as const;
export const CAMPAIGNS_HOME_INTEGRATIONS_PANEL =
  'campaigns-home-integrations' as const;
export const CAMPAIGNS_GET_STARTED_PANEL = 'campaigns-get-started' as const;
export const CMS_EMPTY_STATE_PANEL = 'cms/empty' as const;
export const CMS_ITEMS_LIST_PANEL = 'cms/items' as const;
export const CMS_ITEM_EDIT_PANEL = 'cms/item/edit' as const;
export const CMS_ITEM_BRIEF_PANEL = 'cms/item/brief' as const;
export const CMS_COLLECTION_SETTINGS_PREVIEW_PANEL =
  'cms/collection/edit/preview' as const;
export const CMS_COLLECTION_SETTINGS_PANEL = 'cms/collection/edit' as const;
export const CMS_CSV_ITEM_IMPORT_PANEL = 'cms/csv' as const;
export const COMMERCE_GETTING_STARTED_PANEL =
  'commerce/gettingStarted' as const;
export const COMMERCE_DISCOUNTS_LIST_PANEL = 'commerce/discounts' as const;
export const COMMERCE_DISCOUNT_EDIT_PANEL = 'commerce/discounts/edit' as const;
export const COMMERCE_ORDERS_LIST_PANEL = 'commerce/orders' as const;
export const COMMERCE_SUBSCRIPTIONS_LIST_PANEL =
  'commerce/subscriptions' as const;
export const COMMERCE_SETTINGS_PANEL = 'settings/commerce' as const;
export const EMAILS_PANEL = 'settings/email' as const;
export const GLOBAL_STYLE_COMPONENTS_PANEL =
  'settings/globalStyleComponents' as const;
export const INSTRUCTIONS_PANEL = 'instructions' as const;
export const LIBRARIES_PANEL = 'libraries' as const;
export const LOGIC_FLOWS_PANEL = 'flows' as const;
export const LOGIC_FLOWS_FLOWS_PANEL = 'flows/flows' as const;
export const LOGIC_FLOWS_FLOWS_AUTHORING_PANEL =
  'flows/flows/authoring' as const;
export const LOGIC_FLOWS_VALUES_PANEL = 'flows/values' as const;
export const NAVIGATOR_PANEL = 'navigator' as const;
export const PAGES_PANEL = 'pages' as const;
export const PAGE_SETTINGS_PANEL = 'pageSettings' as const;
export const APPS_PANEL = 'apps' as const;
export const APPS_APP_PANEL = 'apps/app' as const;
export const APPS_MARKETPLACE_APP_PANEL = 'apps/marketplaceApp' as const;
export const SITE_SETTINGS_PANEL = 'siteSettings' as const;
export const INTERFACE_SETTINGS_PANEL = 'interface' as const;
export const GSAP_INTEGRATION_PANEL = 'gsapIntegration' as const;
export const CODE_DEPENDENCY_PANEL = 'codeDependency' as const;
export const LOCAL_DEV_SETTINGS_PANEL = 'localDevSettings' as const;
export const PROPS_MANAGEMENT_PANEL = 'propsManagement' as const;
export const SYMBOLS_PANEL = 'symbols' as const;
export const TUTORIALS_PANEL = 'tutorials' as const;
export const SEARCH_PANEL = SETTINGS_PANEL_SEARCH_SLUG;

export const LOCALIZATION_PANEL = SETTINGS_PANEL_LOCALIZATION_SLUG;
export const ANALYTICS_PANEL = 'analytics';
export const SITE_OVERVIEW = 'site_overview';
export const SITE_GOALS_PANEL = 'site_goals';
export const GOAL_REPORTING_PANEL = 'goal_reporting';
export const PAGE_INSIGHTS = 'page_insights';
export const PAGE_INSIGHTS_DETAILS = 'page_insights_details';
export const OPTIMIZATION_PANEL = 'optimization';
export const ANALYTICS_OPTIMIZATION_PANEL = 'analytics-optimization';
export const ANALYTICS_OPTIMIZATION_SETTINGS_PANEL =
  'analytics-optimization-settings';
export const AUDIENCES_PANEL = 'audiences';
export const AEO_RECOMMENDATIONS_PANEL = 'aeo-recommendations';
export const AEO_ANALYTICS_PANEL = 'aeo-analytics';
export const AEO_PROMPT_DETAIL_PANEL = 'aeo-analytics/prompt-detail';
export const AEO_SEO_PANEL = 'aeo-seo';
export const ORGANIZATION_CONTEXT_PANEL = 'organization-context';
export const EXPERIENCES_PANEL = 'experiences';
export const DATA_EXPLORER_PANEL = 'data-explorer';
export const OPTIMIZATION_INTEGRATION_PANEL = 'optimization-integration';
export const OPTIMIZATION_UPSELL_PANEL = 'optimization-upsell';
export const OPTIMIZATION_OVERVIEW_PANEL = 'optimization-overview';
export const ANALYTICS_UPSELL_PANEL = 'analytics-upsell';
export const ANALYTICS_OPTIMIZATION_LOADING_PANEL =
  'analytics-optimization-loading';
export const BACKUPS_PANEL = 'versions' as const;
export const AUDITOR_PANEL = 'auditor' as const;
export const AUDITOR_SITE_MISSING_ASSET_ALT_TEXT_PANEL =
  'auditor/site-missing-asset-alt-text' as const;
export const STANDARD_AUDIT_PANEL = 'auditor/page-standard-audit' as const;
export const LOCALIZATION_SITE_AUDIT_PANEL =
  'auditor/localization-site-issues' as const;
export const LOCALIZATION_PAGE_AUDIT_PANEL =
  'auditor/localization-page-issues' as const;
export const LOCALIZATION_COMPONENT_AUDIT_PANEL =
  'auditor/localization-component-issues' as const;

export const ADD_LAYOUT_TAB = 'addLayout' as const;
export const HELP_PANEL = 'help' as const;

export type AddTabTypes =
  | typeof ADD_ELEMENT_TAB
  | typeof ADD_LAYOUT_TAB
  | typeof ADD_FROM_LIBRARIES_TAB;

export const STYLES_PANEL = 'styles' as const;
export const TAG_STYLES_PANEL = 'baseStyles' as const;

export const COMMERCE_PANEL = 'commerce/cms' as const;
export const CMS_PANEL = 'cms/cms' as const;
export const FEATURE_CONFIG_PANEL = 'featureConfig' as const;
export const SITE_VARIABLES_PANEL = 'siteVariables' as const;
export const LIBRARY_VARIABLES_PANEL = 'libraryVariables' as const;
export const THEME_PANEL = 'theme' as const;
export const ORION_NAVIGATOR_PANEL = 'orion-navigator' as const;
export const ORION_APPS_LIST_PANEL = 'orion-apps-list' as const;
export const ORION_APP_SETTINGS_PANEL = 'orion-app-settings' as const;

export const MISSING_ALT_TEXT_PANEL = 'missing-alt-text' as const;
export const INTERACTIONS_PANEL = 'interactions' as const;

export const DESIGNER_FEEDBACK_PANEL = 'designerFeedback' as const;

export const CAMPAIGN_REPORTING_PANEL = 'campaign-reporting' as const;
export const COMPONENT_BROWSER_PANEL = 'component-browser' as const;
export const COMPONENT_GROUP_PREVIEW_PANEL = 'component-group-preview' as const;

// Agents mode panels
export const AGENTS_PANEL = 'agents' as const;
export const AGENT_DETAILS_PANEL = 'agent-details' as const;
export const AGENT_TRIGGER_PANEL = 'agent-trigger' as const;
export const CONTEXT_PANEL = 'context' as const;
export const NODE_INFO_PANEL = 'node-info' as const;
export const SECRETS_PANEL = 'secrets' as const;
export const VARIABLE_EDIT_PANEL = 'variable-edit' as const;
